<template>
    <div class="page-content">
        <SketchBreadcrumb pageName="Tutoriale MySmis"></SketchBreadcrumb>
        <div class="padding-box">
            <div class="white-box">
                <div class="title-div">
                    <h3>Tutoriale MySmis</h3>
                </div>
                <div class="tutorials-box">
                    <M3MySmisTutorial v-for="tutorial in tutorials" :key="tutorial.title" :title="tutorial.title" :link="tutorial.link" :greenBackground="tutorial.greenBackground" class="tutorial"></M3MySmisTutorial>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import M3MySmisTutorial from '@/pages/Aplicatii/M3/M3Sketch/components/M3MySmisTutotial.vue'
    import SketchBreadcrumb from '@/pages/Aplicatii/M3/M3Sketch/components/SketchBreadcrumb'

    export default {
        components: {
            M3MySmisTutorial,
            SketchBreadcrumb
        },
        data(){
            return{
                tutorials:[
                    {
                        title:'Crearea contului in MySmis',
                        link:'https://www.youtube.com/embed/z85TW_DmguE',
                        greenBackground:false
                    },
                    {
                        title:'Adăugarea companiei tale la contul MySmis',
                        link:'https://www.youtube.com/embed/yXZWnexlN8c',
                        greenBackground:false
                    },
                    {
                        title:'Completarea informațiilor despre companie',
                        link:'https://www.youtube.com/embed/b8IOX2rLljc',
                        greenBackground:false
                    },
                    {
                        title:'Adăugarea unui proiect',
                        link:'https://www.youtube.com/embed/5r4VULpvLIs',
                        greenBackground:false
                    },
                    {
                        title:'Secțiunea Achiziții',
                        link:'https://www.youtube.com/embed/mmmYPTRynAo',
                        greenBackground:false
                    },
                    {
                        title:'Secțiunea Activități previzionate',
                        link:'https://www.youtube.com/embed/FiorMOkmdJs',
                        greenBackground:false
                    },
                ]
            }
        }
    }
</script>

<style scoped>
.title-div{
    margin-bottom: 20px;
    width: 100%;
    display: flex;
    justify-content: flex-end;
}
.title-div h3{
    font-size: 25px;
    color:#aa93a8;
}
.white-box{
    background: #fff;
    padding: 20px;
    min-height: 100%;
}
.title p{
    font-size: 14px;
}
.video >>> iframe{
    width: 100%;
 }
.tutorials-box{
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    gap: 20px;
}
.flex{
    display: flex;
}
.space-between{
    justify-content: space-between;
}
.tutorial{
    width: 100%;
}


@media (min-width:1700px){
    .tutorial{
        flex-basis: 31%;
    }

}
@media (min-width:1200px){
    .tutorial{
        max-width: 48%;
    }

}
@media (max-width:1199px){
    .tutorial{
        max-width: 100%;
    }
}
</style>
